import { apiGet, apiPost } from '@/shared/utils/requestBuilder';
import { parseApiResponse } from '@/shared/utils/apiResponse';
import type {
  CreateQaRunInput,
  QaAllRunsParams,
  QaRunDetail,
  QaRunListPaginated,
  QaRunListResponse,
} from '../../types/qa';

const FLOWS_URL = '/flows';

export const qaService = {
  async startRun(
    flowId: string,
    input: Omit<CreateQaRunInput, 'flowId'>,
  ): Promise<{ runId: string }> {
    const response = await apiPost(`${FLOWS_URL}/${flowId}/qa/run`, input);
    return parseApiResponse<{ runId: string }>(response);
  },

  async listRuns(flowId: string): Promise<QaRunListResponse> {
    const response = await apiGet(`${FLOWS_URL}/${flowId}/qa/runs`);
    const data = await parseApiResponse<QaRunListResponse>(response);
    return data;
  },

  async listAllRuns(params: QaAllRunsParams = {}): Promise<QaRunListPaginated> {
    const query = new URLSearchParams();
    if (params.flowId) query.set('flowId', params.flowId);
    if (params.page) query.set('page', String(params.page));
    if (params.limit) query.set('limit', String(params.limit));
    const qs = query.toString();
    const response = await apiGet(`${FLOWS_URL}/qa/runs${qs ? `?${qs}` : ''}`);
    return parseApiResponse<QaRunListPaginated>(response);
  },

  async getRun(runId: string): Promise<QaRunDetail> {
    const response = await apiGet(`${FLOWS_URL}/qa/runs/${runId}`);
    return parseApiResponse<QaRunDetail>(response);
  },
};
